import { Tab } from '@alifd/next';
import { BefGlobalContext, BefMessageServiceContext } from '@beflam/bef-core';
import { useContext, useEffect, useState } from 'react';
export class AllColleaguesProps {
  data: any;
  onOK: any | undefined;
}
export function AllColleagues(props: AllColleaguesProps) {
  const messageService = useContext(BefMessageServiceContext);
  const sGlobal = useContext(BefGlobalContext) as any;
  const [collgueData, setCollgueData] = useState<any>([]);
  type UserItemType = {
    Name: string;
    Id: string;
    Description: string;
    Icon: string;
  };
  const refresh = async (_isShow: boolean = false) => {
    try {
      let _data = [] as any;
      if (props.data.length > 0) {
        _data = props.data;
      }

      setCollgueData(_data);
    } catch (error) {
      messageService.showMessage(messageService.handleErr(error, 'AI同事获取'));
    }
  };

  const onTabChange = (key: any) => {
    // if (key == 2) {
    //     refreshType();
    // }
  };

  const getMenuItemTem = (item: UserItemType) => {
    return (
      <>
        <div className="menu-card-div" style={{width:'180px',height:'164px'}}>
          <div className="menu-card" style={{flexDirection:'column',gap:'8px'}} onClick={() => onMenuItemClick(item)}>
            <img
              style={{
                width: 52,
                height: 52,
                objectFit: 'contain',
            //    paddingRight: 10,
                margin: 'auto',
                borderRadius: '50%',
              }}
              alt={item.Id}
              src={
                item.Icon
                  ? `${sGlobal.config.host}/${item.Icon}`
                  : './assets/img/avatar1.png'
              }
            ></img>
            <div className="menu-card-right">
              <div style={{width:'100%',textAlign:'center'}}>
                <p title={item.Name}>{item.Name}</p>
                <p className="sub" title={item.Description}>
                  {item.Description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  //点击菜单
  const onMenuItemClick = (colleague: UserItemType) => {
    if (props.onOK) props.onOK(colleague);
  };

  useEffect(() => {
    refresh();
  }, [props.data]);
  return (
    <>
      <div className=" bef-custom-fun bef-fun">
        <div className="bef-fun-main">
          <div className="tab-div">
            <Tab
              onChange={onTabChange}
              unmountInactiveTabs
              defaultActiveKey="0"
              excessMode="slide"
            >
              <Tab.Item title={'AI同事'} key={0}>
                <div className="menu-con-scroll">
                  <div className="menu-con tab-item">
                    <>
                      {collgueData?.map((item2: UserItemType) =>
                        getMenuItemTem(item2)
                      )}
                    </>
                  </div>
                </div>
              </Tab.Item>
            </Tab>
          </div>
        </div>
      </div>
    </>
  );
}
